import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Card.module.css";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Adds the citron glow ring — for the primary/featured surface. */
  featured?: boolean;
  children: ReactNode;
}

export function Card({ featured = false, className, children, ...rest }: CardProps) {
  return (
    <div
      className={[styles.card, featured ? styles.featured : "", className ?? ""].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </div>
  );
}
